import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatInputModule } from '@angular/material/input';
import { NgModule } from '@angular/core';

import { MessageBoxModule } from '@component/message-box';
import { MessageInputModule } from '@component/message-input';
import { ModalModule } from '@component/modal';

import { ConfirmationModalComponent } from './confirmation-modal.component';

@NgModule({
  declarations: [ConfirmationModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    InlineSVGModule,
    MatInputModule,
    MessageBoxModule,
    MessageInputModule,
    ModalModule
  ]
})
export class ConfirmationModalModule {}
